<template>
  <router-view />
</template>

<script>
export default {
  name: "TeamsPage",
  breadcrumb: {
    title: "Команды",
    to: { name: "teams" }
  }
};
</script>
